// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import OrdersUsingBundles from './ordersUsingBundles';
import React from 'react';

function OrdersUsingBundlesPage () {

    return (
        <AuthenticatedPage className="atp-page atp-order-using-bundles-page">
            <OrdersUsingBundles />
        </AuthenticatedPage>
    );

}
OrdersUsingBundlesPage.displayNAme = 'OrdersUsingBundlesPage';

export default OrdersUsingBundlesPage;
